'use client';

import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
    SheetDescription,
} from '@/components/ui/sheet';
import FaIcon from '../layout/FaIcon';
import menuIcon from '@/assets/svg/menu.svg';
import Image from 'next/image'; 

import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import rubika from '@/assets/rubika.svg';
export default function MenuMobile({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <Sheet>
            <SheetTrigger>
                <Image
                    src={menuIcon}
                    alt="منو"
                    width={1000}
                    height={1000}
                    className="sm:!size-[40px] size-[30px]"
                />
            </SheetTrigger>
            <SheetContent className="overflow-y-auto bg-[#F9FCFB] !w-[290px] !rounded-l-lg">
                <SheetHeader>
                    <SheetTitle className="flex items-center justify-around mx-10">
                        <FaIcon />
                    </SheetTitle>
                    <h1 className="text-xs font-medium text-[#2222228A] text-center">
                        نوبت‌دهی اینترنتی و آنلاین پزشکان ایران
                    </h1>
                </SheetHeader>
                {children}

                <SheetDescription className="flex absolute w-full gap-3 bottom-0 left-0 pb-6 p-4 justify-center text-xl text-blue">
                    <a
                        href="https://wa.me/09338505757"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="border border-main text-blue rounded-full p-2 bg-transparent"
                        title="واتساپ درمان شیرین"
                    >
                        <FaWhatsapp
                            name="whatsapp-icon"
                            className="text-[#207f42]"
                        />
                    </a>
                    <a
                        href="https://t.me/DarmanShirin"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="border border-main text-blue rounded-full p-2 bg-transparent"
                        title="تلگرام درمان شیرین"
                    >
                        <FaTelegramPlane name="telegram-icon" />
                    </a>
                    {/* <Link
                            href={''}
                            className="border border-main text-blue rounded-full p-2 bg-transparent"
                            prefetch={false}
                            title="اینستاگرام درمان شیرین"
                        >
                            <Image
                                src={instagram}
                                width={1000}
                                height={1000}
                                alt="اینستاگرام درمان شیرین"
                                className="size-[20px]"
                            />
                        </Link> */}
                    <a
                        href={'https://rubika.ir/Darmanshirin'}
                        className="border border-main text-blue rounded-full p-2 bg-transparent"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="روبیکا درمان شیرین"
                    >
                        <Image
                            src={rubika}
                            width={1000}
                            height={1000}
                            alt="روبیکا درمان شیرین"
                            className="size-[20px]"
                        />
                    </a>
                </SheetDescription>
            </SheetContent>
        </Sheet>
    );
}
